import CardDetailWorkout from 'components/molecules/Card/Detail/Workout';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as exercisesAC } from 'store/exercises';
import { getExercises, getSelectedExercise } from 'store/exercises';
import { getWeight } from 'store/profile';
import { actionCreators as itemAC } from 'store/programItems';
import {
	getDescription,
	getDescriptionShort,
	getIntensity,
	getIsDone,
	getPausePerWorkoutSet,
	getRepetitionsPerWorkoutSet,
	getSelectedCalories,
	getSelectedDuration,
	getSelectedExerciseId,
	getTitle,
	getToolList,
	getWorkoutCalories,
	getWorkoutSets,
	getWorkoutTotalDuration,
} from 'store/programItems';
import { getIsCustomItem } from 'store/programItems';
import { actionCreators as transientPoolAC } from 'store/transientPoolState';

// Sequences
import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

const mapStateToProps = (state: any, ownProps: any) => {
	const selectedExerciseId = getSelectedExerciseId(state, ownProps.id);

	return {
		title: getTitle(state, ownProps.id),
		isDone: getIsDone(state, ownProps.id),
		intensity: getIntensity(state, ownProps.id),
		energyKcal: ((calories: number, profileWeight: number) => {
			if (!calories || !profileWeight) {
				return 0;
			}
			return calories * profileWeight;
		})(getWorkoutCalories(state, ownProps.id), getWeight(state) as any),
		totalDuration: getWorkoutTotalDuration(state, ownProps.id),
		descriptionShort: getDescriptionShort(state, ownProps.id),
		description: getDescription(state, ownProps.id),
		toolList: getToolList(state, ownProps.id),
		tableList: { items: getWorkoutSets(state, ownProps.id) },
		repetitionsPerWorkoutSet: getRepetitionsPerWorkoutSet(state, ownProps.id),
		pausePerWorkoutSet: getPausePerWorkoutSet(state, ownProps.id),
		// Custom Workout
		selectedExerciseId,
		selectedExercise: getSelectedExercise(state, selectedExerciseId),
		selectedCalories: getSelectedCalories(state, ownProps.id),
		selectedDuration: getSelectedDuration(state, ownProps.id),
		weight: getWeight(state),
		exercises: getExercises(state),
		isCustom: getIsCustomItem(state, ownProps.id),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...exercisesAC,
			...itemAC,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailWorkout, [Sequences.CARD_IS_CHECKING, Sequences.CARD_IS_POSTPONING]) as any);
